import { render, staticRenderFns } from "./Identificacao.vue?vue&type=template&id=1d05755c"
import script from "./Identificacao.vue?vue&type=script&lang=js"
export * from "./Identificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports